import { render } from "./Number.vue?vue&type=template&id=508e0f16&scoped=true&ts=true"
import script from "./Number.vue?vue&type=script&lang=ts"
export * from "./Number.vue?vue&type=script&lang=ts"

import "./Number.vue?vue&type=style&index=0&id=508e0f16&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508e0f16"]])

export default __exports__